import { render } from "./GlobalMap.vue?vue&type=template&id=e4be3e04"
import script from "./GlobalMap.vue?vue&type=script&lang=js"
export * from "./GlobalMap.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__